import { render, staticRenderFns } from "./ModalImportDiscountsTabs.vue?vue&type=template&id=cc5d1078"
import script from "./ModalImportDiscountsTabs.vue?vue&type=script&lang=js"
export * from "./ModalImportDiscountsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports